<template>
  <div class="bs3-margin-bottom15">
    <address class="bs3-margin-bottom5">
      <a :href="showOrganizationInfoUrl" class="ngPopup"><strong>{{pOrganizationRef.name}}</strong></a><br/>
      <div v-for="(addressLine, index) in addressLines" :key="pOrganizationRef.id +'address'+index">{{addressLine}}</div>
      <span v-if="!hasAddress" class="emptyOrNull">{{pDictionary['dictionary.organization.address.none']}}</span>
    </address>
    <div v-if="hasProductionInstructions">
      <div v-for="(instructionsLine, index) in productionInstructionsLines" :key="pOrganizationRef.id +'instructions'+index">{{instructionsLine}}</div>
    </div>
  </div>
</template>

<script>
import stringhelpers from "@/helpers/string-helpers"
import urlhelpers from "@/helpers/url-helpers"
export default {
  name: "OrganizationSummary",
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pSrc: String,
    pSrcId: String,
    pOrganizationRef: Object
  },
  computed: {
    showOrganizationInfoUrl: function() {
      let url = this.pUrls['showOrganizationInfo'] + '?dataId=' + this.pOrganizationRef.id;
      url = urlhelpers.appendIfDefined(url, 'src', this.pSrc);
      url = urlhelpers.appendIfDefined(url, 'srcId', this.pSrcId);
      url = urlhelpers.appendIfDefined(url, 'form', true);
      url = urlhelpers.appendIfDefined(url, 'ajax', true);
      return url;
    },
    hasAddress: function() {
      return this.pOrganizationRef.params.address;
    },
    addressLines: function() {
      return stringhelpers.getLines(this.pOrganizationRef.params.address);
    },
    hasProductionInstructions: function() {
      return this.pOrganizationRef.params.productionInstructions;
    },
    productionInstructionsLines: function() {
      return stringhelpers.getLines(this.pOrganizationRef.params.productionInstructions);
    },
  }
}
</script>

<style scoped>

</style>